import React, { useState } from 'react'
import styles from '../../../styles/pages/user/editordashboard/editor-pendingpublication-video-page.module.scss'
import { Backdrop, Box, Button, CircularProgress, Stack, Tooltip, Typography } from '@mui/material'
import videoPage from '../../../public/assets/images/videoPageImg.png'
import CopyLinkIcon from '../../../public/assets/icons/CopyLinkIcon'
import VideoButtonGroup from '../../../components/VideoButtonGroup/VideoButtonGroup'
import DownloadArrowIcon from '../../../public/assets/icons/DownloadArrowIcon'
import CopyBlueIcon from '../../../public/assets/icons/CopyBlueIcon'
import CrossBlackIcon from '../../../public/assets/icons/CrossBlackIcon'
import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import LinkAddIcon from '../../../ui/Icons/LinkAddIcon'
import RightBlackIcon from '../../../ui/Icons/RightBlackIcon'
import VideoUpbuttonOptionPending from '../../../components/VideoUpbuttonOption/VideoUpbuttonOptionPending'
import BackLinkIcon from '../../../ui/Icons/BackLinkIcon'
import SaveLinkIcon from '../../../ui/Icons/SaveLinkIcon'
import EditLInkIcon from '../../../ui/Icons/EditLInkIcon'
import RoundRightIcon from '../../../ui/Icons/RoundRightIcon'

const EditorPendingPublicationVideoPage = () => {

  const [expanded, setExpanded] = React.useState(false);
  const [saved, setsaved] = useState(false);
  const [open, setOpen] = React.useState(false);
  const [linkButton, setlinkButton] = useState({youtube:false, post:false});

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const handleClose = () => {
    setOpen(false);
    setsaved(false);
    setlinkButton(false);
  };
  const handleOpen = () => {
    setOpen(true);
    setTimeout(() => {
      setsaved(true);
    }, 2000);
  };


  return (
    <Box className={styles.publishVideoPage}>
      <PerfectScrollbar className={styles.editorPublishScroll}>
        <Box className={styles.videoPageMain}>

          <Box className={styles.videoPageMainLeft}>
            <Box className={styles.videosection}>
              <Box className={styles.videoSectionvideo}>
                <img src={videoPage} alt="" />
                <VideoUpbuttonOptionPending />
              </Box>

              <Box className={styles.videoLink}>
                <input type="text" placeholder='https://downloads.viralsnare.com/videos/2lKiIrdf5451df1JKYKpWpb.MOV' />
                <Button><CopyLinkIcon /></Button>
              </Box>

              <Box className={styles.videoButtonGroup}>
                <VideoButtonGroup />
              </Box>

              <Box className={styles.downloadVideo}>
                <Button><DownloadArrowIcon /> Download Video</Button>
                <Button className={styles.confirmBtn} onClick={handleOpen}><RightBlackIcon /> Confirm Update</Button>
              </Box>
            </Box>

            <Box className={styles.publishVideonotification}>
              <Typography variant='body1'>Video pending publication since January 22, 2023 at 07:56 PM UTC.</Typography>
            </Box>

            <Box className={styles.submissionDetailsBox}>
              <Typography variant='h2'>Submission Details</Typography>

              <Box className={styles.submissionVideoBox}>
                <Box className={styles.submissionDetailsHeader}><Typography variant='h3'>Original Video File (VS Link)</Typography></Box>
                <Box className={styles.submissionOriginal}>
                  <Typography variant='body1'>https://downloads.viralsnare.com/videos/2lKiIrdf5451df1JKYKpWpb.MOV </Typography>
                  <Box className={styles.copyIcon}><Tooltip title="Add" placement="top" arrow={true}><Button><CopyBlueIcon /></Button></Tooltip></Box>
                </Box>
              </Box>

              <Box className={styles.submissionWrapBox}>

                <Box className={styles.submissionWrapSmallBox}>
                  <Box className={styles.submissionVsidBox}>
                    <Box className={styles.submissionDetailsHeader}><Typography variant='h3'>VSID</Typography></Box>
                    <Box className={styles.submissionOriginal}>
                      <Typography variant='body1'>VS1558FDVFDV </Typography>
                      <Box className={styles.copyIcon}><Tooltip title="Add" placement="top" arrow={true}><Button><CopyBlueIcon /></Button></Tooltip></Box>
                    </Box>
                  </Box>
                </Box>

                <Box className={styles.submissionWrapSmallBox}>
                  <Box className={styles.submissionDateBox}>
                    <Box className={styles.submissionDetailsHeader}><Typography variant='h3'>Submission Date</Typography></Box>
                    <Box className={styles.submissionOriginal}>
                      <Typography variant='body1'>September 30, 2023 at 03:24:04 PM UTC </Typography>
                      <Box className={styles.copyIcon}><Tooltip title="Add" placement="top" arrow={true}><Button><CopyBlueIcon /></Button></Tooltip></Box>
                    </Box>
                  </Box>
                </Box>

                <Box className={styles.submissionWrapSmallBox}>
                  <Box className={styles.submissionShareBox}>
                    <Box className={styles.submissionDetailsHeader}><Typography variant='h3'>Revenue Share</Typography></Box>
                    <Box className={styles.submissionOriginal}>
                      <Typography variant='body1'>60% </Typography>
                      <Box className={styles.copyIcon}><Tooltip title="Add" placement="top" arrow={true}><Button><CopyBlueIcon /></Button></Tooltip></Box>
                    </Box>
                  </Box>
                </Box>

                <Box className={styles.submissionWrapSmallBox}>
                  <Box className={styles.submissionAcquiBox}>
                    <Box className={styles.submissionDetailsHeader}><Typography variant='h3'>Acquisitor</Typography></Box>
                    <Box className={styles.submissionOriginal}>
                      <Typography variant='body1'>Muhammad Ali Waqas <span>(Content Buyer)</span> </Typography>
                      <Box className={styles.copyIcon}><Tooltip title="Add" placement="top" arrow={true}><Button><CopyBlueIcon /></Button></Tooltip></Box>
                    </Box>
                  </Box>
                </Box>

              </Box>

            </Box>
          </Box>

          <Box className={styles.videoPageMainRight}>
            <Box className={styles.teamNotesBox}>
              <Typography variant='h3'>Team Notes</Typography>
              <Typography variant='body1'>Fusce eget lacus non turpis porttitor gravida sit amet quis tellus. Morbi tempus finibus elit in ultrices. Nunc sagittis purus nisl, eu elementum risus
                faucibus vita. Integer molestie, ex sit amet semper aliquam, mauris odio dignissim velit, suscipit feugiat massa est varius lectus. Phasellus euismod lacinia tortor ac finibus.
                Maecenas semper consectetur venenatis. Nullam eget felis gravida, consectetur lacus nec, fermentum metus. Suspendisse ac tellus...</Typography>
              <Button><CrossBlackIcon /></Button>
            </Box>

            <Box className={styles.videoPageAccordian}>
              <Accordion expanded={expanded === 'panel1'} onChange={handleChange('panel1')} disabled>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1bh-content"
                  id="panel1bh-header"
                >
                  <Box className={styles.accordianHeading}>
                    <Typography variant='body1'>Team Messages</Typography>
                  </Box>
                  <Box className={styles.accordianButtonGrp}>
                    <Button>Admin</Button>
                    <Button>QC Agent</Button>
                    <Button>Copywriter</Button>
                  </Box>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography>
                    Nulla facilisi. Phasellus sollicitudin nulla et quam mattis feugiat.
                    Aliquam eget maximus est, id dignissim quam.
                  </Typography>
                </AccordionDetails>
              </Accordion>
            </Box>

            <Box className={styles.videoMetaData}>
              <Typography variant='h3'>Video Metadata</Typography>

              <Box className={`${styles.titleBox} ${styles.titleBoxActive}`}>
                <Typography variant='h4'>Title</Typography>
                <Typography variant='body1'>this is a titled written by a copywriter. <CopyBlueIcon /></Typography>
              </Box>

              <Box className={`${styles.descriptionBox} ${styles.descriptionBoxActive}`}>
                <Typography variant='h4'>Description</Typography>
                <Typography variant='body1'>Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa.
                  Cum sociis natoque penatibus et magnis dis parturient montes <CopyBlueIcon /></Typography>
              </Box>

              <Box className={`${styles.tagBox} ${styles.tagBoxActive}`}>
                <Typography variant='h4'>Tags</Typography>
                <Box className={styles.tagButton}>
                  <Button>fail</Button>
                  <Button>funny</Button>
                  <Button>crash</Button>
                  <CopyBlueIcon />
                </Box>
              </Box>

              <Box className={styles.filmingWrapMain}>
                <Box className={styles.filmingWrap}>
                  <Box className={styles.filmingLocationBox}>
                    <Typography variant='h4'>Filming Location</Typography>
                    <Typography variant='body1'>Miami, Florida, United States <CopyBlueIcon /></Typography>
                  </Box>
                </Box>

                <Box className={styles.filmingWrap}>
                  <Box className={styles.filmingDateBox}>
                    <Typography variant='h4'>Filming Date</Typography>
                    <Typography variant='body1'>March 15, 2023 <CopyBlueIcon /></Typography>
                  </Box>
                </Box>
              </Box>
            </Box>

            <Box className={styles.clientDetails}>
              <Typography variant='h3'>Client Details</Typography>

              <Box className={styles.clientWrapMain}>
                <Box className={styles.clientWrap}>
                  <Box className={`${styles.clientLocationBox} ${styles.fullName}`}>
                    <Typography variant='h4'>Full Name</Typography>
                    <Typography variant='body1'>Franciszek Emmanual Hendricks <CopyBlueIcon /></Typography>
                  </Box>
                </Box>

                <Box className={styles.clientWrap}>
                  <Box className={`${styles.clientLocationBox} ${styles.emailAddress}`}>
                    <Typography variant='h4'>Email Address</Typography>
                    <Typography variant='body1'>peyuc_upame47@gmail.com <CopyBlueIcon /></Typography>
                  </Box>
                </Box>

                <Box className={styles.clientWrap}>
                  <Box className={`${styles.clientLocationBox} ${styles.mediaCredit}`}>
                    <Typography variant='h4'>Media Credit</Typography>
                    <Typography variant='body1'>Franciszek_Emmanual <CopyBlueIcon /></Typography>
                  </Box>
                </Box>
              </Box>
            </Box>

            <Box className={styles.uploadDetails}>
              <Typography variant='h3'>Upload Details</Typography>

              <Box className={styles.uploadLinks}>
                <Box className={styles.youtubeLink}>
                  <Box className={styles.youtubeLinkHeader}>
                    <Typography variant='h4'>YouTube Post URL</Typography>
                    <Stack direction={'row'} className={styles.linkEdit}>

                      {
                        linkButton.youtube ?
                          <Stack direction={'row'}>
                            <Button><BackLinkIcon /></Button>
                            <Button onClick={() => setlinkButton({...linkButton,youtube:false})}><SaveLinkIcon /></Button>
                          </Stack>
                          :
                          <Button onClick={() => setlinkButton({...linkButton,youtube:true})}><EditLInkIcon /></Button>
                      }


                    </Stack>
                  </Box>
                  <Box className={styles.youtubeLinkError}>
                    <input type='' placeholder='https://www.youtube.com/watch?v=sgf_G_Kv6zo' />
                    <Typography variant='body1'>The URL you entered is not a valid YouTube URL</Typography>
                  </Box>                  
                </Box>

                <Box className={styles.addedDate}>
                  <Typography variant='h4'>Added On</Typography>
                  <input type='' placeholder='September 30, 2023 at 03:24:04 PM UTC' />
                </Box>
              </Box>

              <Box className={styles.uploadLinks}>
                <Box className={styles.youtubeLink}>
                  <Box className={styles.youtubeLinkHeader}>
                    <Typography variant='h4'>Post URL</Typography>
                    <Stack direction={'row'} className={styles.linkEdit}>

                    {
                        linkButton.post ?
                          <Stack direction={'row'}>
                            <Button><BackLinkIcon /></Button>
                            <Button onClick={() => setlinkButton({...linkButton,post:false})}><SaveLinkIcon /></Button>
                          </Stack>
                          :
                          <Button onClick={() => setlinkButton({...linkButton,post:true})}><EditLInkIcon /></Button>
                      }


                    </Stack>
                  </Box>
                  <input type='' placeholder='https://www.youtube.com/watch?v=sgf_G_Kv6zo' />
                </Box>

                <Box className={styles.addedDate}>
                  <Typography variant='h4'>Added On</Typography>
                  <input type='' placeholder='September 30, 2023 at 03:24:04 PM UTC' />
                </Box>
              </Box>

              <Box className={styles.linkAddButton}>
                <Button><LinkAddIcon /> Add another URL</Button>
              </Box>

              <Box className={styles.saveBtnGrp}>
                  <Button className={`${styles.saveBtnGrpInactive} ${styles.saveBtnGrpActive}`}><RoundRightIcon/> Mark as Complete</Button>
                  <Button className={styles.cancelBtn}>Cancel</Button>
              </Box>
            </Box>
          </Box>

        </Box>
      </PerfectScrollbar>

      <Backdrop
        sx=
        {{
          color: '#fff',
          zIndex: (theme) => theme.zIndex.drawer + 1,
        }}
        open={open}
        onClick={handleClose}
        className={styles.backDropBarWrap}
      >
        {saved ?
          <Box className={styles.backDropBarSucces}>
            <Typography variant='body1'>Metadata updated Successfully</Typography>
          </Box>

          :

          <Box className={styles.backDropBar}>
            <CircularProgress color="inherit" />
            <Typography variant='body1'>Saving</Typography>
          </Box>
        }



      </Backdrop>
    </Box>
  )
}

export default EditorPendingPublicationVideoPage